import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { TabMenu } from 'primereact/tabmenu'

import { Header } from '../../../components/Header'

export const MasterDataManagement: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  // Determine active index based on current URL
  const getActiveIndexFromPath = (pathname: string): number => {
    if (pathname.includes('/packaging-data')) return 0
    if (pathname.includes('/company-codes')) return 1
    if (pathname.includes('/suppliers')) return 2
    return 0 // Default to packaging-data
  }

  const [activeIndex, setActiveIndex] = useState(
    getActiveIndexFromPath(location.pathname),
  )

  // Update active index when URL changes
  useEffect(() => {
    setActiveIndex(getActiveIndexFromPath(location.pathname))
  }, [location.pathname])

  const items = [
    {
      label: t('masterDataManagement.tabMenu.packagingMaterials.label'),
      command: () => {
        navigate('packaging-data')
      },
    },
    {
      label: t('masterDataManagement.tabMenu.companyCodes.label'),
      command: () => {
        navigate('company-codes')
      },
    },
    {
      label: t('masterDataManagement.tabMenu.suppliers.label'),
      command: () => {
        navigate('suppliers')
      },
    },
  ]

  return (
    <>
      <div className="bg-white mb-6 -mx-6 px-6">
        <Header title={t('masterDataManagement.title.title')} />
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={e => setActiveIndex(e.index)}
          className="overflow-visible"
        />
      </div>

      <Outlet />
    </>
  )
}
